import { Role } from "../types/Role/Role";
import api from "../utils/api";
import { GET_ROLE_BY_ID_URL as url } from "../utils/endpoints";

export async function getRoleById(id?: string, auth?: string | null) {
  try {
    const config = {
      headers: {
        Authorization: auth ? `Bearer ${auth}` : "",
      },
    };

    const response = await api.get(`${url}?RoleId=${id}`, config);
    const data: Role = response.data.name;

    return data;
  } catch (error) {
    throw error;
  }
}
